import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Or Mnlexpress if it's your main component
import Mnlexpress from './mnlexpress';

import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css'; // ✅ Don't forget this

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
  fontFamily: "Salmond, sans-serif",
});

root.render(
  <React.StrictMode>
    <MantineProvider theme={theme} withGlobalStyles withNormalizeCSS>
      <Notifications position="top-right" /> {/* ✅ Enables pop-up notifications */}
      <Mnlexpress /> {/* Or <App /> if you’re using that instead */}
    </MantineProvider>
  </React.StrictMode>
);

reportWebVitals();
